import { render, staticRenderFns } from "./DepositPromoDialog.vue?vue&type=template&id=6e8b5cd4&scoped=true&"
import script from "./DepositPromoDialog.vue?vue&type=script&lang=js&"
export * from "./DepositPromoDialog.vue?vue&type=script&lang=js&"
import style0 from "./DepositPromoDialog.vue?vue&type=style&index=0&id=6e8b5cd4&lang=scss&scoped=true&"
import style1 from "./DepositPromoDialog.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8b5cd4",
  null
  
)

export default component.exports